// hooks/usePersistentState.ts
import { useState, useEffect } from 'react';

/**
 * Même API que useState, mais la valeur est
 * lue/écrite dans localStorage sous la clé passée en paramètre.
 */
export function usePersistentState<T>(
  storageKey: string,
  defaultValue: T
): [T, React.Dispatch<React.SetStateAction<T>>] {
  // Lecture initiale
  const [value, setValue] = useState<T>(() => {
    if (typeof window === 'undefined') return defaultValue;        // SSR safety
    try {
      const stored = window.localStorage.getItem(storageKey);
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  // Écriture à chaque changement
  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(value));
    } catch {
      /* quota exceeded ou private‑mode – on ignore */
    }
  }, [storageKey, value]);

  return [value, setValue];
}
